import Layout from './features/layout/Layout';
function App() {
  return (
  
    <Layout></Layout>
  
  );
}

export default App;
